<template>
  <!-- 首页右上角个人信息 -->
  <AppDialog
    v-if="config.visible"
    v-model="config.visible"
    :title="title"
    width="730px"
    height="390px"
    top="8vh"
    custom-class="home-user-info-dialog"
    @success="successFn"
  >
    <div class="container">
      <div class="profile-header">
        <AppAvatar
        class="header-avatar"
        :name="userInfo.nickName || userInfo.userName"
        width="64"
        :avatar="userInfo.avatar"
        :no-name="true"
      />
      <div class="header-info">
        <div>
          <span class="header-laber">员工姓名：</span><span> {{ data.nickName }}</span>
        </div>
        <div>
          <span class="header-laber">手机号码：</span><span>{{ data.phoneNumber }}</span>
        </div>
        <div>
          <span class="header-laber">所在部门：</span><span>{{ data.deptName }}</span>
        </div>
        <div class="text_hidden_3">
          <span class="header-laber">角色组：</span><span>{{ data.roleNames }}</span>
        </div>
        </div>
      </div>
      <el-divider />
      <div class="bind-section">
        <CorpWxAccountBindTabs
        v-if="config.visible && data.userId"
        :user-id="data.userId"
        :phone="data.phoneNumber || ''"
        @change="getBindList"
      >
        <div>
          第三方账号绑定：<el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            class="m-l-10"
            @click="openBindTypeDialog()"
          >新增</el-button>
        </div>
        <div class="thirdAccounts-container">
          <div
            v-for="(item, index) in bindList"
            :key="index"
            class="third-account-card"
          >
            <div class="card-header">
              <span class="tag-wechat">企业微信</span>
              <div class="actions">
                <span class="action-btn bind-btn" @click="openBindTypeDialog(item)">换绑</span>
                <span class="action-btn unbind-btn" @click="delThirdAccounts(item, index)">解绑</span>
              </div>
            </div>
            <div class="card-content">
              <div class="user-info">
                <el-image :src="typeof item === 'object' ? (item.avatar || item.headImageUrl || item.bizWechatAvatar || '') : ''" class="avatar">
                  <template slot="error">
                    <img src="~@/assets/image/imgloadError.png" class="avatar" />
                  </template>
                </el-image>
                <div class="name-info">
                  <span class="user-name">{{ typeof item === 'string' ? item : (item.nickName || item.userName || item.name || item.employeeName || item.bizWechatName || '未命名') }}</span>
                </div>
              </div>
              <div class="corp-name">
                {{ typeof item === 'object' ? (item.corpName || item.companyName || item.customerName || '已绑定企业微信') : '已绑定企业微信' }}
              </div>
            </div>
          </div>
        </div>
        </CorpWxAccountBindTabs>
      </div>
    </div>
    
    <!-- 选择绑定方式弹窗 -->
    <el-dialog
      :title="isRebind ? '选择换绑方式' : '选择绑定方式'"
      :visible.sync="bindTypeVisible"
      width="400px"
      append-to-body
    >
      <div class="bind-type-list">
        <div class="bind-type-item" @click="chooseScanBind">
          <i class="el-icon-full-screen bind-type-icon" />
          <div class="bind-type-text">
            <div class="bind-type-name">扫码绑定</div>
            <div class="bind-type-desc">使用企业微信扫码完成绑定</div>
          </div>
          <i class="el-icon-arrow-right bind-type-arrow" />
        </div>
        <div class="bind-type-item" @click="choosePhoneBind">
          <i class="el-icon-mobile-phone bind-type-icon" />
          <div class="bind-type-text">
            <div class="bind-type-name">手机号绑定</div>
            <div class="bind-type-desc">通过手机号绑定企业微信</div>
          </div>
          <i class="el-icon-arrow-right bind-type-arrow" />
        </div>
      </div>
    </el-dialog>

    <!-- 手机号绑定/换绑弹窗 -->
    <el-dialog
      :title="isRebind ? '手机号换绑' : '手机号绑定'"
      :visible.sync="phoneBindVisible"
      width="400px"
      append-to-body
      @close="closePhoneBindDialog"
    >
      <div style="padding: 10px 0;">
        <el-input
          v-model.trim="phoneInput"
          maxlength="11"
          placeholder="请输入手机号"
          clearable
        >
          <template slot="prepend">手机号</template>
        </el-input>
      </div>
      <div slot="footer">
        <el-button size="small" @click="closePhoneBindDialog">取消</el-button>
        <el-button
          type="primary"
          size="small"
          :loading="phoneBindLoading"
          @click="submitPhoneBind"
        >确定</el-button>
      </div>
    </el-dialog>

    <!-- 扫码绑定/换绑弹窗 -->
    <el-dialog
      :title="isRebind ? '企业微信换绑' : '企业微信绑定'"
      :visible.sync="qrCodeVisible"
      width="400px"
      append-to-body
      @close="closeQrCodeDialog"
    >
      <div v-loading="qrCodeLoading" style="text-align: center; padding: 30px 0;">
        <template v-if="!bindSuccess">
          <i class="el-icon-link" style="font-size: 48px; color: #409EFF; margin-bottom: 16px;"></i>
          <div style="margin-bottom: 24px; color: #666; font-size: 14px; line-height: 1.5;">
            请点击下方按钮在新窗口中打开企业微信页面进行扫码{{ isRebind ? '换绑' : '绑定' }}。
          </div>
          <div>
            <el-button type="primary" @click="openWechatAuth">前往扫码{{ isRebind ? '换绑' : '绑定' }}</el-button>
            <el-button @click="closeQrCodeDialog">我已完成{{ isRebind ? '换绑' : '绑定' }}</el-button>
          </div>
        </template>
        <template v-else>
          <i class="el-icon-success" style="font-size: 64px; color: #67C23A; margin-bottom: 16px;"></i>
          <div style="color: #67C23A; font-size: 18px; font-weight: bold;">
            {{ bindSuccessText }}
          </div>
        </template>
      </div>
    </el-dialog>
  </AppDialog>
</template>

<script>
import AppDialog from '@/components/AppDialog'
import { userPageNew, editUser } from '@/api/addressBookApi'
import { mapGetters } from 'vuex'
import AppAvatar from '@/components/AppAvatar/AppAvatar.vue'
import CorpWxAccountBindTabs from '@/components/CorpWxAccountBindTabs'
import { getOptionsValueByKey } from '@/filters/index'
import { getQrCodeUrl, getRebindQrCodeUrl, getCropBindList, unbindCropUser, bindCropUserByPhone, rebindCropUserByPhone } from '@/api/privateArea/CRM.js'
import { getItem } from '@/utils/localStorage'

export default {
  components: {
    AppDialog,
    AppAvatar,
    CorpWxAccountBindTabs
  },
  props: {
    config: {
      type: Object,
      default: () => {
        return {
          visible: false
        }
      }
    }
  },
  data() {
      return {
        title: '个人信息',
        data: {
          thirdAccounts: [],
          roleNames: ''
        },
        thirdAccountsTypeOption: [],
        ishow: false,
        bindList: [],
        qrCodeVisible: false,
        qrCodeUrl: '',
        qrCodeLoading: false,
        bindSuccess: false,
        bindSuccessText: '绑定成功',
        isRebind: false,
        bindTypeVisible: false,
        pendingBindItem: null,
        phoneBindVisible: false,
        phoneInput: '',
        phoneBindLoading: false
      }
    },
  computed: {
    ...mapGetters(['userInfo']),
    computedQrCodeUrl() {
      if (!this.qrCodeUrl) return ''
      // 企业微信内部应用扫码授权
      if (this.qrCodeUrl.includes('login_type=')) {
        return this.qrCodeUrl.replace(/login_type=[^&]*/, 'login_type=CorpApp')
      }
      const sep = this.qrCodeUrl.includes('?') ? '&' : '?'
      return this.qrCodeUrl + sep + 'login_type=CorpApp'
    }
  },
  watch: {
    'config.visible': {
      handler(val) {
        if (val) {
          this.init()
        }
      },
      deep: true
    }
  },

  methods: {
    getOptionsValueByKey,
    async init() {
      await this.getUserInfo()
      await this.getBindList()
    },
    // 获取绑定列表
    async getBindList() {
      try {
        const { data } = await getCropBindList()
        const orgInfo = getItem('orgInfo') || {}
        this.bindList = (data || []).filter(item => !item.sourceTenantId || String(item.sourceTenantId) === String(orgInfo.organizationId))
      } catch (error) {
        console.error(error)
      }
    },
    // 获取个人信息
    async getUserInfo() {
      const { data } = await userPageNew()
      const infoData = data || {}
      const roleNamesArray = []
      const roleIds = []
      let roleNames = ''
      if (infoData.roleVoList) {
        infoData.roleVoList.map(v => {
          roleIds.push(v.roleId)
          roleNamesArray.push(v.roleName)
        })
      }
      roleNames = roleNamesArray.join('、')
      const thirdAccounts = []
      if (infoData.erpId) {
        thirdAccounts.push({ type: 1, erpCode: infoData.erpId })
      }
      this.data = { ...infoData, thirdAccounts, roleNames, roleIds }
    },
    // 点击新增第三方账号绑定 或 换绑：先弹出绑定方式选择
    openBindTypeDialog(item) {
      const relationId = item && typeof item === 'object'
        ? item.id || item.relationId
        : null
      this.isRebind = !!relationId
      this.pendingBindItem = item && typeof item === 'object' ? item : null
      this.bindTypeVisible = true
    },
    // 选择扫码绑定
    chooseScanBind() {
      this.bindTypeVisible = false
      this.addThirdAccounts(this.pendingBindItem)
    },
    // 选择手机号绑定：默认带出当前用户手机号，支持修改
    choosePhoneBind() {
      this.phoneInput = this.data.phoneNumber || ''
      this.bindTypeVisible = false
      this.phoneBindVisible = true
    },
    closePhoneBindDialog() {
      this.phoneBindVisible = false
      this.phoneInput = ''
      this.phoneBindLoading = false
    },
    // 通过手机号绑定/换绑企业微信用户
    async submitPhoneBind() {
      const phone = this.phoneInput
      if (!phone) {
        this.$message.warning('请输入手机号')
        return
      }
      if (!/^1[3-9]\d{9}$/.test(phone)) {
        this.$message.warning('请输入正确的手机号')
        return
      }
      const relationId = this.pendingBindItem
        ? this.pendingBindItem.id || this.pendingBindItem.relationId
        : null
      const orgInfo = getItem('orgInfo') || {}
      const params = {
        tenantId: orgInfo.organizationId,
        userId: this.data.userId,
        phone
      }
      this.phoneBindLoading = true
      try {
        await (relationId
          ? rebindCropUserByPhone(relationId, params)
          : bindCropUserByPhone(params))
        this.$message.success(this.isRebind ? '换绑成功' : '绑定成功')
        this.closePhoneBindDialog()
        this.getBindList()
      } catch (error) {
        console.error(error)
      } finally {
        this.phoneBindLoading = false
      }
    },
    // 点击新增第三方账号绑定 或 换绑
    async addThirdAccounts(item) {
      this.qrCodeVisible = true
      this.qrCodeLoading = true
      const relationId = item && typeof item === 'object'
        ? item.id || item.relationId
        : null
      this.isRebind = !!relationId
      try {
        const { data } = relationId
          ? await getRebindQrCodeUrl(relationId)
          : await getQrCodeUrl()
        this.qrCodeUrl = data
        // 监听 iframe 回调页发送的 postMessage
        window.addEventListener('message', this.handleIframeMessage)
      } catch (error) {
        console.error(error)
      } finally {
        this.qrCodeLoading = false
      }
    },
    // 打开新窗口进行微信授权
    openWechatAuth() {
      if (this.computedQrCodeUrl) {
        this.authWindow = window.open(this.computedQrCodeUrl, '_blank')
        // 轮询检查新窗口是否被关闭
        if (this.checkWindowTimer) clearInterval(this.checkWindowTimer)
        this.checkWindowTimer = setInterval(() => {
          if (this.authWindow && this.authWindow.closed) {
            clearInterval(this.checkWindowTimer)
            this.closeQrCodeDialog()
          }
        }, 1000)
      }
    },
    handleIframeMessage(event) {
      if (event.origin !== window.location.origin) return
      const data = event.data
      if (!data) return

      const isSuccess =
        data === 'bind_success' ||
        data.type === 'bind_success' ||
        data.code === 1 ||
        data.success === true ||
        (data.type === 'crop_bind_result' && data.success === true)

      if (isSuccess) {
        const successText = data.msg || data.message || (this.isRebind ? '换绑成功' : '绑定成功')
        this.bindSuccess = true
        this.bindSuccessText = successText
        this.$message.success(successText)
        if (this.authWindow && !this.authWindow.closed) {
          this.authWindow.close()
        }
        // 延迟1.5秒后关闭弹窗
        setTimeout(() => {
          this.closeQrCodeDialog()
        }, 1500)
      } else if (data === 'bind_error' || data.type === 'bind_error' || data.code === 0 || data.code === 500) {
        this.$message.error(data.msg || data.message || '绑定失败')
      } else if (data.msg || data.message) {
        // 兜底处理其他带有 msg 的对象
        this.$message.error(data.msg || data.message)
      }
    },
    closeQrCodeDialog() {
      this.qrCodeVisible = false
      if (this.checkWindowTimer) clearInterval(this.checkWindowTimer)
      window.removeEventListener('message', this.handleIframeMessage)
      setTimeout(() => {
        this.bindSuccess = false // 动画结束后重置状态
        this.bindSuccessText = '绑定成功'
        this.isRebind = false
      }, 300)
      this.getBindList()
    },
    // 点击解绑第三方账号
    delThirdAccounts(item, index) {
      this.$delModal({
        tips: '是否确认解绑？解绑后对应绑定的企业微信将失效！',
        success: async () => {
          try {
            const relationId = typeof item === 'string' ? item : (item.id || item.relationId)
            const res = await unbindCropUser(relationId)
            if (res.code === 1) {
              this.$message.success('解绑成功')
              this.getBindList()
            }
          } catch (e) {
            console.error(e)
          }
        }
      })
    },
    // 复用“确定”按钮提交逻辑
    submitUserInfo({ closeOnSuccess = true } = {}) {
      const data = this.data
      data.thirdAccounts.map(v => {
        if (v.type === 1) {
          // 博商erp
          data.erpCode = v.erpCode
        }
      })
      const params = {
        deptId: data.deptId,
        phoneMode: data.phoneMode,
        roleIds: data.roleIds,
        status: data.status,
        userId: data.userId,
        userName: data.userName,
        nickName: data.nickName,
        employeeType: data.employeeType,
        erpCode: data.erpCode,
        wechatPhone: data.wechatPhone,
        bizWechatId: data.bizWechatId
      }
      editUser(params).then(res => {
        if (res.code === 1) {
          if (closeOnSuccess) this.config.visible = false
        }
      })
    },
    // 提交（确定按钮）
    successFn() {
      this.submitUserInfo({ closeOnSuccess: true })
    }
  },
  beforeDestroy() {
    if (this.checkWindowTimer) clearInterval(this.checkWindowTimer)
    window.removeEventListener('message', this.handleIframeMessage)
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 14px 24px 0;
  .profile-header {
    display: flex;
    align-items: center;
    flex: 0 0 72px;
    min-height: 0;
  }
  .header-avatar {
    flex: 0 0 64px;
    flex-direction: row !important;
    justify-content: flex-start !important;
  }
  .header-info {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    align-content: center;
    margin: 0 0 0 20px;
    line-height: 20px;
    color: #333;
    > *:nth-child(1),
    *:nth-child(3) {
      flex: 0 0 50%;
    }
    > *:nth-child(2),
    *:nth-child(4) {
      flex: 0 0 45%;
    }
    > *:nth-child(3),
    *:nth-child(4) {
      margin-top: 8px;
    }
  }
  ::v-deep > .el-divider {
    width: 100%;
    margin: 10px 0;
    flex: 0 0 auto;
  }
  .bind-section {
    display: flex;
    flex: 1;
    min-height: 0;
    flex-direction: column;
  }
  ::v-deep .corp-wx-account-bind {
    display: flex;
    flex: 1;
    min-height: 0;
    flex-direction: column;
  }
  ::v-deep .corp-wx-account-bind .el-tabs {
    display: flex;
    flex: 1;
    min-height: 0;
    flex-direction: column;
  }
  ::v-deep .corp-wx-account-bind .el-tabs__header {
    flex: 0 0 auto;
    margin: 0 0 10px;
  }
  ::v-deep .corp-wx-account-bind .el-tab-pane > div:first-child {
    display: flex;
    align-items: center;
    min-height: 32px;
  }
  ::v-deep .corp-wx-account-bind .el-tabs__content {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  }
  ::v-deep .corp-wx-account-bind .el-tab-pane {
    padding-bottom: 8px;
  }
  .thirdAccounts-container {
    margin-top: 14px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
    padding-right: 0;
  }
  .header-laber {
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #777777;
  }

  .third-account-card {
    width: calc(50% - 8px);
    flex-shrink: 0;
    border: 1px solid #E4E7ED;
    border-radius: 8px;
    padding: 10px;
    box-sizing: border-box;

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;

      .tag-wechat {
        border: 1px solid #409EFF;
        color: #409EFF;
        padding: 2px 8px;
        border-radius: 4px;
        font-size: 12px;
      }

      .actions {
        font-size: 14px;
        .action-btn {
          cursor: pointer;
          margin-left: 12px;
        }
        .bind-btn {
          color: #409EFF;
        }
        .unbind-btn {
          color: #F56C6C;
        }
      }
    }

    .card-content {
      border: 1px solid #E4E7ED;
      border-radius: 8px;
      overflow: hidden;

      .user-info {
        display: flex;
        align-items: center;
        padding: 12px;
        justify-content: center;

        .avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-right: 12px;
        }

        .name-info {
          display: flex;
          flex-direction: column;
          .user-name {
            font-size: 16px;
            color: #333;
            font-weight: 500;
          }
        }
      }

      .corp-name {
        background: #F5F7FA;
        padding: 8px 16px;
        text-align: center;
        font-size: 13px;
        color: #909399;
      }
    }
  }
}

.bind-type-list {
  padding: 10px 0;
  .bind-type-item {
    display: flex;
    align-items: center;
    padding: 14px 16px;
    border: 1px solid #dcdfe6;
    border-radius: 6px;
    cursor: pointer;
    transition: border-color .2s;
    & + .bind-type-item {
      margin-top: 12px;
    }
    &:not(.bind-type-disabled):hover {
      border-color: #409eff;
      .bind-type-icon,
      .bind-type-name {
        color: #409eff;
      }
    }
    .bind-type-icon {
      font-size: 26px;
      color: #606266;
      margin-right: 12px;
    }
    .bind-type-text {
      flex: 1;
      .bind-type-name {
        font-size: 14px;
        font-weight: 500;
        color: #333;
      }
      .bind-type-desc {
        font-size: 12px;
        color: #909399;
        margin-top: 4px;
      }
    }
    .bind-type-arrow {
      color: #c0c4cc;
      font-size: 14px;
    }
    .bind-type-tag {
      font-size: 12px;
      color: #c0c4cc;
    }
    &.bind-type-disabled {
      cursor: not-allowed;
      background: #f5f7fa;
      .bind-type-icon,
      .bind-type-name,
      .bind-type-desc {
        color: #c0c4cc;
      }
    }
  }
}
</style>
